import { render, staticRenderFns } from "./ReportGenerator.vue?vue&type=template&id=47f112e4&scoped=true"
import script from "./ReportGenerator.vue?vue&type=script&lang=js"
export * from "./ReportGenerator.vue?vue&type=script&lang=js"
import style0 from "./ReportGenerator.vue?vue&type=style&index=0&id=47f112e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f112e4",
  null
  
)

export default component.exports